import { ifDefined, universalEach } from "@faedev/editor-utils";
import replaceString from "src/functions/replaceString";
import translate from "src/functions/translate";

function getYogaStyles(data: { id: string; title: string }[], lang: string) {
  return universalEach(data, (item, i) => {
    return {
      item: ifDefined(
        item.type,
        (value) => translate(replaceString(value, `_`, ` `), lang),
        () => ``
      ),
      url: `#`,
    };
  });
}

export default getYogaStyles;
